import {Component, OnInit} from '@angular/core';
import {Router, ActivatedRoute} from '@angular/router';
import {Location} from '@angular/common';
import {AlertService, WidgetService, CampaignService, StorageService} from '../_services';
import {PreviewFormComponent} from '../preview';
import {FormBuilder} from '@angular/forms';

@Component({
  moduleId: module.id.toString(),
  selector: 'widget-preview-form',
  templateUrl: '../preview/preview-form.component.html',
  styleUrls: ['../preview/preview-form.component.scss'],
})
export class WidgetPreviewFormComponent extends PreviewFormComponent implements OnInit {
  constructor(protected router: Router,
              protected location: Location,
              protected route: ActivatedRoute,
              protected formBuilder: FormBuilder,
              protected widgetService: WidgetService,
              protected alertService: AlertService,
              protected campaignService: CampaignService,
              protected storageService: StorageService
  ) {
    super(router, location, route, formBuilder, widgetService, alertService, campaignService, storageService);
  }

  ngOnInit() {
    super.ngOnInit();
  }

}
